import { History } from 'history';
import React from 'react';
import { useFeatureServices } from './use-feature-services';

export const HistoryContext = React.createContext<History | undefined>(
  undefined,
);

export function useHistory(): History {
  const { 's2:history': historyService } = useFeatureServices();

  return historyService.history;
}
